import { render } from "./ProjectorPage.vue?vue&type=template&id=d6468cec&scoped=true"
import script from "./ProjectorPage.vue?vue&type=script&lang=js"
export * from "./ProjectorPage.vue?vue&type=script&lang=js"

import "./ProjectorPage.vue?vue&type=style&index=0&id=d6468cec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6468cec"]])

export default __exports__